import jwtDecode from 'jwt-decode';

export class StorageState {
  constructor() {
    this.storage = localStorage;
    this.token = this.storage.getItem('token');
  }

  isLoggedIn() {
    return !!this.token;
  }

  /**
   * @returns {Number|null}
   */
  getProfileIdInOnSiteStep() {
    const decodedToken = jwtDecode(this.token);
    return decodedToken.profileId;
  }

  setToken(token) {
    this.storage.setItem('token', token);
  }

  setExpiresIn(date) {
    this.storage.setItem('expires_in', date);
  }

  setFeedbackModalVisibility(userName) {
    this.storage.setItem(`feedbackModalSeen_${userName}`, JSON.stringify(true));
  }

  getDecodedToken() {
    return jwtDecode(this.token);
  }
}
